
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import addMenu from "./components/add-menu.vue";
import addAuth from "./components/add-auth.vue";
import {
  getSystemAll,
  getSystemList,
  delSystem,
  delPrivilege
} from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-add-menu": addMenu,
    "pi-add-auth": addAuth
  }
})
export default class PiMenuManage extends Vue {
  private formItem: objAny = {
    subsystemPkId: ""
  };
  private systemList: object[] = [];
  private addMenuBox: objAny = {};
  private addAuth: objAny = {};
  private loading = false;

  private columns: object[] = [
    {
      title: i18n.t("menuList.moduleName"),
      key: "moduleName",
      tree: true,
      minWidth: 120
    },
    {
      title: i18n.t("menuList.englishName"),
      key: "englishName",
      minWidth: 120
    },
    {
      title: i18n.t("menuList.thailandName"),
      key: "thailandName",
      minWidth: 120
    },
    {
      title: i18n.t("menuList.privilegeVoList"),
      key: "privilegeVoList",
      slot: "privilegeVoList",
      minWidth: 200
    },
    {
      title: i18n.t("operation"),
      key: "action",
      minWidth: 120,
      slot: "action"
    }
  ];
  private menuList: object[] = [];

  public sysChange() {
    this.getSystemList();
  }

  async getSystemAll(): Promise<void> {
    const ret = await getSystemAll({});
    if (ret.status === this.$config.apiStatus) {
      this.systemList = ret.data;
      this.formItem.subsystemPkId = ret.data[0].subsystemPkId;
      this.sysChange();
    }
  }
  async getSystemList(): Promise<void> {
    this.loading = true;
    const ret = await getSystemList(this.formItem);
    if (ret.status === this.$config.apiStatus) {
      this.menuList = ret.data[0] ? ret.data[0].children : [];
    }
    this.loading = false;
  }

  public addMenu(): void {
    this.addMenuBox.open("add");
  }
  public addMenuChild(item: objAny): void {
    this.addMenuBox.open("add", item);
  }
  public upMenuChild(item: objAny): void {
    this.addMenuBox.open("updata", item);
  }
  async delMenu(item: objAny): Promise<void> {
    const ret = await delSystem({ modulePkId: item.modulePkId });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("updateSuccess"));
      this.getSystemList();
    }
  }
  public addAuthClick(item: objAny) {
    this.addAuth.open(item);
  }
  async closeTag(item: objAny): Promise<void> {
    const ret = await delPrivilege({ pkid: item.privilegeId });
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("updateSuccess"));
      this.getSystemList();
    }
  }

  mounted() {
    this.getSystemAll();
    this.addMenuBox = this.$refs["addMenuBox"];
    this.addAuth = this.$refs["addAuth"];
  }
}
